(function () {
  const STORAGE_KEY = "cinta_frete_draft_state_v1";
  const CONTACT_STORAGE_KEY = "cinta_checkout_contact_v1";
  const CHECKOUT_SELECTORS = [
    "#checkout",
    "#checkoutympButton",
    "#checkoutchtButton",
    ".cart__checkout-button",
    ".ymp_check_mainBtn",
    ".cht_check_mainBtn",
  ].join(",");

  function normalizeZipcode(value) {
    return String(value || "").replace(/\D/g, "").slice(0, 8);
  }

  function maskZipcode(value) {
    const digits = normalizeZipcode(value);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }

  function normalizeShippingOptionKey(value) {
    return String(value || "").trim().split("|", 1)[0].toLowerCase();
  }

  function shippingOptionKeysMatch(left, right) {
    const normalizedLeft = normalizeShippingOptionKey(left);
    return normalizedLeft !== "" && normalizedLeft === normalizeShippingOptionKey(right);
  }

  function parseJsonSafe(value) {
    try {
      return JSON.parse(value);
    } catch (_error) {
      return null;
    }
  }

  function getGaTrackingPayload() {
    return window.MansaIntimaGa4Tracking?.getTrackingPayload?.() || { ga_cookie: "", ga_client_id: "" };
  }

  function isLocalThemeDevOrigin() {
    const host = String(window.location.host || "").toLowerCase();
    return host === "localhost:9292" || host === "127.0.0.1:9292";
  }

  function resolveWidgetEndpoint(endpoint) {
    const normalizedEndpoint = String(endpoint || "").trim();
    if (!normalizedEndpoint) return normalizedEndpoint;
    if (!isLocalThemeDevOrigin()) return normalizedEndpoint;
    if (normalizedEndpoint.includes("index-tes34.php")) return normalizedEndpoint;

    return normalizedEndpoint.replace(/index\.php(\?|$)/, "index-tes34.php$1");
  }

  function getFriendlyErrorMessage(error, fallbackMessage) {
    const rawMessage = error instanceof Error ? error.message : String(error || "").trim();
    const normalized = rawMessage.toLowerCase();

    if (
      normalized.includes("failed to fetch") ||
      normalized.includes("networkerror") ||
      normalized.includes("network request failed") ||
      normalized.includes("load failed")
    ) {
      return fallbackMessage || "Não foi possível acessar o cálculo de frete. Verifique sua conexão com a internet e tente novamente.";
    }

    return rawMessage || fallbackMessage || "Erro ao processar a requisição.";
  }

  function normalizeEmail(value) {
    return String(value || "").trim().toLowerCase();
  }

  function isValidEmail(value) {
    const email = normalizeEmail(value);
    return email !== "" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function loadState() {
    return parseJsonSafe(window.localStorage.getItem(STORAGE_KEY)) || {};
  }

  function saveState(nextState) {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(nextState));
  }

  function readContactState() {
    try {
      const parsed = parseJsonSafe(window.localStorage.getItem(CONTACT_STORAGE_KEY));
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch (_error) {
      // localStorage bloqueado ou conteúdo inválido: segue sem contato salvo.
      return {};
    }
  }

  function writeContactState(nextState) {
    try {
      window.localStorage.setItem(CONTACT_STORAGE_KEY, JSON.stringify(nextState));
      window.dispatchEvent(new Event('cinta:contact-saved'));
    } catch (_error) {
      // localStorage bloqueado: o checkout segue normalmente, sem persistir.
    }
  }

  function clearSelectionPreservingZipcode(zipcode) {
    const nextState = {
      zipcode: maskZipcode(zipcode || ""),
      calculated_at: Math.floor(Date.now() / 1000),
    };

    saveState(nextState);
    return nextState;
  }

  async function postJson(url, payload) {
    let response;

    try {
      response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      throw new Error(
        getFriendlyErrorMessage(
          error,
          "Não foi possível acessar o cálculo de frete. Verifique sua conexão com a internet e tente novamente."
        )
      );
    }

    const text = await response.text();
    const json = parseJsonSafe(text);

    if (!response.ok) {
      const message = json && json.error ? json.error : "Erro ao processar a requisição.";
      throw new Error(message);
    }

    if (!json) {
      throw new Error("Resposta inválida do servidor.");
    }

    if (json.success === false || json.error) {
      throw new Error(json.error || "Erro ao processar a requisição.");
    }

    return json;
  }

  async function fetchCartJson() {
    const response = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Não foi possível carregar o carrinho atual.");
    }

    return response.json();
  }

  async function clearCart() {
    const response = await fetch("/cart/clear.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Não foi possível limpar o carrinho antes de redirecionar para o checkout.");
    }

    return response.json();
  }

  function setMessage(widget, message, type) {
    const alert = widget.querySelector("[data-frete-widget-alert]");
    if (!alert) return;

    if (!message) {
      alert.textContent = "";
      alert.hidden = true;
      alert.dataset.state = "";
      return;
    }

    alert.hidden = false;
    alert.dataset.state = type || "info";
    alert.textContent = message;
  }

  function setAddress(widget, text) {
    const address = widget.querySelector("[data-frete-widget-address]");
    if (!address) return;

    if (!text) {
      address.innerHTML = "";
      return;
    }

    address.innerHTML = text;
  }

  function getContextTotal(widget) {
    if (widget.dataset.context === "cart") {
      return null;
    }

    const parsed = Number(widget.dataset.total || 0);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 18;
  }

  function parsePositiveInteger(value) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return 0;
    return Math.max(0, Math.round(parsed));
  }

  function getDefaultWeightGrams(widget) {
    return parsePositiveInteger(widget?.dataset?.defaultWeightGrams) || 70;
  }

  function getProductQuantity(widget) {
    const productScope = widget.closest("product-form-component, form[action*='/cart/add'], .product-details, main") || document;
    const quantityInput =
      productScope.querySelector('input[name="quantity"]') ||
      document.querySelector('main[data-template="product"] input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');
    const quantity = parsePositiveInteger(quantityInput?.value);
    return quantity > 0 ? quantity : 1;
  }

  function getProductWeightGrams(widget) {
    const unitWeight = parsePositiveInteger(widget.dataset.weightGrams) || getDefaultWeightGrams(widget);
    return unitWeight * getProductQuantity(widget);
  }

  function getCartWeightGrams(widget, cart) {
    const defaultWeight = getDefaultWeightGrams(widget);
    return (cart?.items || []).reduce((totalWeight, item) => {
      const quantity = parsePositiveInteger(item?.quantity) || 1;
      const unitWeight = parsePositiveInteger(item?.grams) || defaultWeight;
      return totalWeight + unitWeight * quantity;
    }, 0);
  }

  function getRequestWeightGrams(widget, cart) {
    if (widget.dataset.context === "cart") {
      return getCartWeightGrams(widget, cart);
    }

    return getProductWeightGrams(widget);
  }

  function refreshProductWidgetWeightFromHtml(widget, html) {
    const updatedWidget = html?.querySelector?.('[data-frete-widget][data-context="product"]');
    if (!updatedWidget) return false;

    widget.dataset.weightGrams = String(parsePositiveInteger(updatedWidget.dataset.weightGrams));
    widget.dataset.defaultWeightGrams = String(
      parsePositiveInteger(updatedWidget.dataset.defaultWeightGrams) || getDefaultWeightGrams(widget)
    );
    return true;
  }

  function invalidateFreteSelectionForWidget(widget) {
    ensureWidgetState(widget);
    widget.state.lastAutoCalculatedZipcode = "";
    clearSelectionPreservingZipcode(widget.state.zipcode);
    clearWidgetSelection(widget);
    clearSelectionAcrossWidgets(widget);
  }

  function buildAddressLabel(option) {
    const parts = [option.street, option.city, option.uf].filter(Boolean);
    if (parts.length === 0) return "";

    const addressLabel = escapeHtml(parts.join(" - "));
    const locationIcon = window.themeIcons?.locationDot || "";

    return `
      <span class="frete-widget__address-label">
        ${locationIcon}
        <span class="frete-widget__address-text">${addressLabel}</span>
      </span>
    `;
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function renderServiceDisplay(option) {
    if (option.promotion === "free_shipping_700") return `<span class="frete-widget__cell-main">Frete grátis</span>`;
    const serviceName = String(
      option.service_name || option.service_display_name || option.name || "Frete"
    ).trim();
    const normalized = serviceName.toLowerCase();
    const accessibleLabel = escapeHtml(serviceName);

    if (normalized.includes("sedex") || normalized.includes("pac")) {
      const serviceLabel = normalized.includes("sedex") ? "Sedex" : "Pac";

      return `
        <span class="frete-widget__service-brand" aria-label="${accessibleLabel}" title="${accessibleLabel}">
          <span class="frete-widget__service-logo" aria-hidden="true"></span>
          <span class="frete-widget__service-text">${serviceLabel}</span>
          <span class="frete-widget__sr-only">${accessibleLabel}</span>
        </span>
      `;
    }

    if (normalized.includes("retirada na loja")) {
      const storeIcon = window.themeIcons?.store || "";

      return `
        <span class="frete-widget__service-brand" aria-label="${accessibleLabel}" title="${accessibleLabel}">
          <span class="frete-widget__service-icon-fa" aria-hidden="true">
            ${storeIcon}
          </span>
          <span class="frete-widget__service-text">Retirada na Loja</span>
          <span class="frete-widget__sr-only">${accessibleLabel}</span>
        </span>
      `;
    }

    return `<span class="frete-widget__cell-main">${accessibleLabel}</span>`;
  }

  function updateButtonLoading(widget, isLoading) {
    const continuation = widget.querySelector('[data-frete-continue]');
    if (continuation && widget.dataset.checkoutRequested === 'true') {
      const checkoutBusy = widget.classList.contains('frete-widget--submitting') || Boolean(document.querySelector('[data-direct-checkout="true"].is-loading'));
      const busy = isLoading || checkoutBusy;
      continuation.hidden = !isLoading && !widget.state?.selectedOption;
      continuation.disabled = busy;
      continuation.classList.toggle('is-loading', busy);
      continuation.setAttribute('aria-busy', busy ? 'true' : 'false');
      continuation.innerHTML = busy ? '<span class="direct-checkout-spinner" aria-hidden="true"></span><span class="frete-widget__sr-only">Calculando frete</span>' : 'Finalizar Compra';
    }
    const button = widget.querySelector("[data-frete-widget-calculate]");
    if (!button) return;

    const originalLabel = button.dataset.originalLabel || button.textContent.trim();
    button.dataset.originalLabel = originalLabel;
    button.disabled = isLoading;
    button.classList.toggle("frete-widget__button--loading", isLoading);
    button.setAttribute("aria-busy", isLoading ? "true" : "false");
    button.textContent = originalLabel;
  }

  function getCartTotalNode() {
    return document.querySelector("[data-cart-subtotal]");
  }

  function formatCartMoney(cents) {
    const totalNode = getCartTotalNode();
    const moneyFormat = totalNode ? String(totalNode.dataset.cartMoneyFormat || "").trim() : "";

    if (
      moneyFormat &&
      window.Shopify &&
      typeof window.Shopify.formatMoney === "function"
    ) {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format((Number(cents) || 0) / 100);
  }

  function updateCartEstimatedTotal(totalCents) {
    const totalNode = getCartTotalNode();
    if (!totalNode) return;

    const formatted = formatCartMoney(totalCents);
    totalNode.textContent = formatted;
    totalNode.setAttribute("value", formatted);
  }

  function updateCartShippingSummary(option) {
    const row = document.querySelector("[data-cart-shipping-row]");
    const value = document.querySelector("[data-cart-shipping-value]");

    if (!row || !value) return;

    if (!option) {
      row.hidden = true;
      value.textContent = formatCartMoney(0);
      return;
    }

    const shippingCents = Math.round(Number(option.price || 0) * 100);
    row.hidden = false;
    value.textContent = shippingCents <= 0 ? "Grátis" : formatCartMoney(shippingCents);
  }

  function resetCartEstimatedTotal() {
    const totalNode = getCartTotalNode();
    if (!totalNode) return;

    const baseTotalCents = Number(totalNode.dataset.cartBaseTotalCents || 0);
    updateCartEstimatedTotal(baseTotalCents);
    updateCartShippingSummary(null);
  }

  function syncCartEstimatedTotalWithShipping(cart, option) {
    if (!cart || !option) {
      resetCartEstimatedTotal();
      return;
    }

    const cartTotalCents = Number(cart.total_price || 0);
    const shippingCents = Math.round(Number(option.price || 0) * 100);
    updateCartEstimatedTotal(cartTotalCents + shippingCents);
    updateCartShippingSummary(option);
  }

  function setCheckoutLoading(widget, isLoading) {
    document.documentElement.classList.toggle("frete-draft-checkout-loading", isLoading);
    if (!widget) return;

    widget.classList.toggle("frete-widget--submitting", isLoading);
    widget.setAttribute("aria-busy", isLoading ? "true" : "false");
  }

  function isCheckoutLoadingStatePresent() {
    if (document.documentElement.classList.contains("frete-draft-checkout-loading")) {
      return true;
    }
    if (document.querySelector(".frete-widget--submitting")) {
      return true;
    }
    if (document.querySelector('[data-direct-checkout="true"].is-loading')) {
      return true;
    }
    return false;
  }

  function handlePageRestore(event) {
    if (!event.persisted || !isCheckoutLoadingStatePresent()) return;

    document.documentElement.classList.remove("frete-draft-checkout-loading");
    document.querySelectorAll(".frete-widget--submitting").forEach((widget) => {
      widget.classList.remove("frete-widget--submitting");
      widget.setAttribute("aria-busy", "false");
    });

    window.location.reload();
  }

  function scrollToFreightWidget(widget) {
    if (!widget || typeof widget.scrollIntoView !== "function") return;

    widget.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  }

  function shouldClearCartOnSuccess(widget) {
    return String(widget.dataset.clearCartOnSuccess || "true") === "true";
  }

  async function trackBeginCheckout(cart, selectedOption) {
    if (window.CintaAnalytics?.trackBeginCheckout) {
      await window.CintaAnalytics.trackBeginCheckout(cart, selectedOption);
    }
  }

  function buildDraftCartPayload(cart) {
    return {
      token: cart.token,
      currency: cart.currency,
      total_price: cart.total_price,
      total_discount: cart.total_discount || 0,
      discount_codes: cart.discount_codes || [],
      cart_level_discount_applications: cart.cart_level_discount_applications || [],
      item_count: cart.item_count,
      items: (cart.items || []).map((item) => ({
        variant_id: item.variant_id,
        quantity: item.quantity,
      })),
    };
  }

  function getKnownCustomerEmail(widget) {
    return normalizeEmail(widget?.dataset?.customerEmail || "");
  }

  function requestPaymentMethod(widget, { opener, signal } = {}) {
    if (signal?.aborted) return Promise.resolve(null);
    if (widget?.dataset.pixCheckoutEnabled !== "true" || isPrecheckoutEnabled(widget)) {
      return Promise.resolve("normal");
    }

    let modal = document.querySelector("[data-checkout-payment-modal]");
    if (!modal) {
      modal = document.createElement("dialog");
      modal.className = "frete-email-modal frete-payment-modal";
      modal.dataset.checkoutPaymentModal = "true";
      modal.setAttribute("aria-labelledby", "frete-payment-modal-title");
      modal.setAttribute("aria-describedby", "frete-payment-modal-description");
      modal.hidden = true;
      modal.innerHTML = `
        <div class="frete-email-modal__panel">
          <div class="frete-email-modal__header">
            <h2 class="frete-email-modal__title" id="frete-payment-modal-title" tabindex="-1">Como você prefere pagar?</h2>
            <button type="button" class="frete-email-modal__close" data-checkout-payment-cancel aria-label="Fechar">&times;</button>
          </div>
          <p class="frete-email-modal__description" id="frete-payment-modal-description">Escolha como continuar sua compra.</p>
          <div class="frete-payment-modal__choices">
            <button type="button" class="frete-payment-modal__choice frete-payment-modal__choice--pix" data-checkout-payment-choice="pix">
              <svg class="frete-payment-modal__icon" viewBox="0 0 901 900" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <g transform="translate(0 900) scale(.1 -.1)">
        <path d="m4265 8986c-216-42-357-99-536-217-83-54-204-172-1001-968-500-498-908-909-908-913 0-5 92-8 204-8 288 0 449-33 646-132 186-94 194-101 985-889 413-411 766-755 785-765 49-26 181-26 230 0 19 10 368 350 775 755 642 640 752 746 834 800 241 159 431 218 735 228l178 6-888 889c-489 489-920 913-959 943-157 121-324 202-519 252-88 22-127 26-296 29-136 2-216-1-265-10z"></path>
        <path d="m861 5935c-485-487-577-584-630-664-102-154-154-272-199-450-25-99-27-121-27-321 0-191 3-225 24-310 49-199 134-377 256-535 30-38 299-315 598-614l544-543 359 1c403 2 467 8 607 55 204 69 179 48 1022 887 759 756 760 756 845 798 197 96 409 94 603-5 66-35 130-95 812-774 446-444 766-756 807-784 79-56 187-107 289-137 68-20 102-23 419-29 190-3 352-9 360-13 11-5 167 145 586 565 488 490 580 587 633 667 34 52 73 116 87 142 195 385 195 873 0 1258-14 26-53 90-87 142-53 80-145 177-633 667-419 420-575 570-586 565-8-4-170-10-360-13-317-6-351-9-419-29-102-30-210-81-289-137-40-28-364-343-812-789-802-798-778-776-930-823-175-53-368-27-525 70-29 18-367 347-805 782-837 833-813 812-1017 882-136 46-219 54-616 56l-348 3-568-570z"></path>
        <path d="m4465 3913c-47-14-101-65-805-767-796-793-804-800-990-894-196-99-359-132-647-132-112 0-203-3-203-8 0-4 408-415 908-913 797-796 918-914 1001-968 154-102 272-154 450-199 99-25 121-27 321-27 191 0 225 3 310 24 199 49 377 134 535 256 39 30 470 454 959 943l888 889-178 6c-304 10-494 69-735 228-82 54-193 161-839 805-722 719-747 743-799 758-67 19-110 19-176-1z"></path>
      </g>
    </svg>
              <span><strong>Pix com 5% de desconto</strong></span>
            </button>
            <button type="button" class="frete-payment-modal__choice" data-checkout-payment-choice="normal">
              <svg class="frete-payment-modal__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Zm0 14H4v-7h16Zm0-11H4V6h16Z"/></svg>
              <span><strong>Outros meios de pagamento</strong><small>Continuar sem o desconto de 5% no Pix.</small></span>
            </button>
          </div>
          <button type="button" class="frete-payment-modal__back" data-checkout-payment-cancel>Voltar ao produto</button>
        </div>
      `;
      document.body.appendChild(modal);
    }
    if (modal._paymentChoicePending) return Promise.resolve(null);
    modal._paymentChoicePending = true;

    return new Promise((resolve) => {
      let settled = false;
      const finish = (method) => {
        if (settled) return;
        settled = true;
        modal.removeEventListener("click", onClick);
        modal.removeEventListener("cancel", onCancel);
        modal.removeEventListener("keydown", onKeydown);
        modal.removeEventListener("close", onClose);
        signal?.removeEventListener("abort", onCancel);
        if (modal.open) modal.close();
        modal.hidden = true;
        delete modal._paymentChoicePending;
        document.documentElement.classList.remove("frete-email-modal-open");
        document.body.classList.remove("frete-email-modal-open");
        if (opener?.isConnected) opener.focus({ preventScroll: true });
        resolve(method);
      };
      const onCancel = (event) => {
        event?.preventDefault();
        finish(null);
      };
      const onClose = () => { if (!modal.open) finish(null); };
      const onKeydown = (event) => { if (event.key === "Escape") onCancel(event); };
      const onClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const choice = target?.closest("[data-checkout-payment-choice]");
        if (choice) {
          const method = choice.dataset.checkoutPaymentChoice;
          if (method === "pix" || method === "normal") finish(method);
        } else if (event.target === modal || target?.closest("[data-checkout-payment-cancel]")) {
          finish(null);
        }
      };
      modal.addEventListener("click", onClick);
      modal.addEventListener("cancel", onCancel);
      modal.addEventListener("keydown", onKeydown);
      modal.addEventListener("close", onClose);
      signal?.addEventListener("abort", onCancel, { once: true });
      document.documentElement.classList.add("frete-email-modal-open");
      document.body.classList.add("frete-email-modal-open");
      modal.hidden = false;
      try {
        modal.showModal();
        modal.querySelector("h2").focus();
      } catch (_error) {
        finish(null);
        setMessage(widget, "Não foi possível abrir a escolha de pagamento. Tente novamente.", "error");
      }
    });
  }

  function createProductEmailModal() {
    const modal = document.createElement("dialog");
    modal.className = "frete-email-modal";
    modal.dataset.freteEmailModal = "true";
    modal.dataset.freteEmailContext = "product";
    modal.hidden = true;
    modal.innerHTML = `
      <div class="frete-email-modal__panel" role="dialog" aria-modal="true" aria-labelledby="frete-product-email-modal-title">
        <div class="frete-email-modal__header">
          <h2 class="frete-email-modal__title" id="frete-product-email-modal-title">Informe seu e-mail</h2>
          <button type="button" class="frete-email-modal__close" data-frete-email-cancel aria-label="Fechar">&times;</button>
        </div>
        <p class="frete-email-modal__description">Usaremos este e-mail para identificar seu pedido e enviar as informações do pagamento.</p>
        <form data-frete-email-form novalidate>
          <label class="frete-email-modal__field">E-mail
            <input type="email" autocomplete="email" inputmode="email" data-frete-email-input required>
          </label>
          <label class="frete-email-modal__marketing">
            <input type="checkbox" data-frete-email-marketing checked>
            <span>Quero receber novidades e ofertas da Mansa Íntima por e-mail.</span>
          </label>
          <p class="frete-email-modal__error" data-frete-email-error hidden></p>
          <div class="frete-email-modal__actions">
            <button type="button" class="frete-email-modal__cancel" data-frete-email-cancel>Voltar</button>
            <button type="submit" class="frete-email-modal__submit">Continuar</button>
          </div>
        </form>
      </div>
    `;
    document.body.appendChild(modal);
    return modal;
  }

  function getEmailModal(widget) {
    const context = widget?.dataset?.context || "cart";
    const selector = `[data-frete-email-modal][data-frete-email-context="${context}"]`;
    const modal =
      document.body.querySelector(selector) ||
      document.querySelector(selector) ||
      (context === "product" ? createProductEmailModal() : null);

    // The cart modal is rendered inside the cart drawer. Move it to the body
    // so position: fixed uses the viewport instead of the drawer's width.
    if (modal && modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    return modal;
  }

  function closeEmailModal(modal, resolver, result) {
    if (!modal) return;
    if (typeof modal.close === "function" && modal.open) {
      modal.close();
    }
    modal.hidden = true;
    modal.removeAttribute("data-open");
    document.documentElement.classList.remove("frete-email-modal-open");
    document.body?.classList.remove("frete-email-modal-open");
    if (typeof resolver === "function") {
      resolver(result);
    }
  }

  function requestCheckoutEmail(widget) {
    const knownEmail = getKnownCustomerEmail(widget);

    // Logged-in customers already have a validated contact. Do not reopen the
    // capture modal just to display the same e-mail; marketing consent still
    // requires an explicit interaction with the checkbox.
    if (isValidEmail(knownEmail)) {
      return Promise.resolve({
        email: knownEmail,
        marketingConsent: false,
      });
    }

    const modal = getEmailModal(widget);
    if (!modal) {
      return Promise.reject(new Error("Não foi possível abrir o campo de e-mail."));
    }

    if (modal.dataset.open === "true" && modal._checkoutEmailPromise) {
      return modal._checkoutEmailPromise;
    }

    const form = modal.querySelector("[data-frete-email-form]");
    const input = modal.querySelector("[data-frete-email-input]");
    const marketing = modal.querySelector("[data-frete-email-marketing]");
    const error = modal.querySelector("[data-frete-email-error]");
    const cancelButtons = modal.querySelectorAll("[data-frete-email-cancel]");

    if (!form || !input || !marketing || !error) {
      return Promise.reject(new Error("O formulário de e-mail está incompleto."));
    }

    const contactState = readContactState();
    const savedEmail = normalizeEmail(contactState.email || "");
    const marketingAuthorized = Boolean(contactState.marketing_authorized);
    const marketingRow = marketing.closest(".frete-email-modal__marketing") || marketing;

    modal.hidden = false;
    if (typeof modal.showModal === "function" && !modal.open) {
      modal.showModal();
    }
    modal.dataset.open = "true";
    document.documentElement.classList.add("frete-email-modal-open");
    document.body?.classList.add("frete-email-modal-open");
    error.hidden = true;
    error.textContent = "";
    // Visitante não autenticado: preenche com o e-mail salvo, mas mantém editável.
    input.value = isValidEmail(savedEmail) ? savedEmail : "";
    input.readOnly = false;
    input.setAttribute("aria-readonly", "false");
    // Checkbox marcado por padrão; ocultado apenas quando a API confirmou
    // consentimento para o e-mail salvo (não tratamos o checkbox como prova).
    marketing.checked = true;

    const applyMarketingVisibility = () => {
      const current = normalizeEmail(input.value);
      const hide = isValidEmail(current) && marketingAuthorized && current === savedEmail;
      marketingRow.style.display = hide ? "none" : "";
    };
    applyMarketingVisibility();
    input.oninput = applyMarketingVisibility;

    modal._checkoutEmailPromise = new Promise((resolve) => {
      const cleanup = () => {
        form.removeEventListener("submit", onSubmit);
        cancelButtons.forEach((button) => button.removeEventListener("click", onCancel));
        modal.removeEventListener("keydown", onKeydown);
        delete modal._checkoutEmailPromise;
        delete modal._checkoutEmailCleanup;
      };

      const finish = (result) => {
        cleanup();
        closeEmailModal(modal, null, null);
        resolve(result);
      };

      const onSubmit = (event) => {
        event.preventDefault();
        const email = normalizeEmail(input.value);
        if (!isValidEmail(email)) {
          error.hidden = false;
          error.textContent = "Informe um e-mail válido para continuar.";
          input.focus();
          return;
        }

        // Guardar o contato informado antes de criar o rascunho também evita
        // que outro convite de e-mail apareça durante uma tentativa de compra.
        // A autorização só é marcada depois de confirmada pela API.
        const previous = readContactState();
        writeContactState({
          email,
          marketing_authorized: normalizeEmail(previous.email || "") === email && Boolean(previous.marketing_authorized),
        });

        finish({
          email,
          marketingConsent: Boolean(marketing.checked),
        });
      };

      const onCancel = () => finish(null);
      const onKeydown = (event) => {
        if (event.key === "Escape") onCancel();
      };

      form.addEventListener("submit", onSubmit);
      cancelButtons.forEach((button) => button.addEventListener("click", onCancel));
      modal.addEventListener("keydown", onKeydown);
      modal._checkoutEmailCleanup = onCancel;
      window.requestAnimationFrame(() => input.focus());
    });

    return modal._checkoutEmailPromise;
  }

  async function submitDraftCheckout(widget, cart, selectedOption, checkoutContact, paymentMethod = "normal") {
    const customerId = Number(widget.dataset.customerId || 0);
    const payload = {
      action: "create_draft_order",
      payment_method: paymentMethod,
      zipcode: widget.state.zipcode,
      selected_option_key: selectedOption.option_key,
      email: normalizeEmail(checkoutContact?.email || ""),
      marketing_consent: Boolean(checkoutContact?.marketingConsent),
      tracking: getGaTrackingPayload(),
      cart: buildDraftCartPayload(cart),
    };

    if (customerId > 0) {
      payload.customer = { id: customerId };
    }

    const response = await postJson(widget.dataset.endpoint, payload);
    if (!response.invoice_url) {
      throw new Error("A Shopify não retornou a URL do draft order.");
    }

    persistCheckoutContact(checkoutContact, response);

    await trackBeginCheckout(cart, selectedOption);

    if (shouldClearCartOnSuccess(widget)) {
      await clearCart();
    }

    window.location.href = response.invoice_url;
  }

  function persistCheckoutContact(checkoutContact, response) {
    // Só persiste quando o rascunho foi criado com sucesso (invoice_url válida).
    const email = normalizeEmail(checkoutContact?.email || "");
    if (!isValidEmail(email) || !response.invoice_url) {
      return;
    }

    const previous = readContactState();
    const previousEmail = normalizeEmail(previous.email || "");
    const previousAuthorized = Boolean(previous.marketing_authorized);
    const sameEmail = previousEmail === email;

    // Autorização confirmada vem apenas da API; se a mesma pessoa reutilizar o
    // e-mail, a autorização já confirmada é preservada. Trocar de e-mail remove
    // a autorização armazenada do endereço anterior.
    const authorized = Boolean(response.marketing_consent_recorded)
      ? true
      : sameEmail
        ? previousAuthorized
        : false;

    writeContactState({ email, marketing_authorized: authorized });
  }

  function persistSelectedOption(widget, option, cart) {
    const currentState = loadState();
    const nextState = {
      ...currentState,
      zipcode: maskZipcode(widget.state.zipcode),
      selected_option_key: option.option_key,
      selected_option_name: option.service_name,
      draft_shipping_title: option.draft_shipping_title,
      price: option.price,
      formatted_price: option.formated_price,
      delivery_label: option.delivery_label,
      previsao_entrega: option.previsao_entrega || "",
      context_origin: widget.dataset.context,
      cart_item_count: cart ? cart.item_count : currentState.cart_item_count,
      cart_total_price: cart ? cart.total_price : currentState.cart_total_price,
      calculated_at: Math.floor(Date.now() / 1000),
    };

    saveState(nextState);
  }

  function markSelectedRow(widget, selectedKey) {
    widget.querySelectorAll("[data-frete-option-row]").forEach((row) => {
      const selected = shippingOptionKeysMatch(row.dataset.optionKey, selectedKey);
      row.classList.toggle("frete-widget__row--selected", selected);
      row.setAttribute("aria-selected", selected ? "true" : "false");
      const radio = row.querySelector("[data-frete-option-radio]");
      if (radio) radio.checked = selected;
    });
  }

  function ensureWidgetState(widget) {
    if (!widget) return;

    if (!widget.dataset.resolvedEndpoint) {
      widget.dataset.endpoint = resolveWidgetEndpoint(widget.dataset.endpoint);
      widget.dataset.resolvedEndpoint = "true";
    }

    if (!widget.state) {
      widget.state = {
        options: [],
        selectedOption: null,
        zipcode: "",
        autoCalculateTimer: null,
        lastAutoCalculatedZipcode: "",
        checkoutSubmitting: false,
        emailCapturePending: false,
      };
    }
  }

  function clearWidgetSelection(widget) {
    const continuation = widget.querySelector("[data-frete-continue]");
    if (continuation) continuation.hidden = true;
    ensureWidgetState(widget);
    widget.state.selectedOption = null;
    markSelectedRow(widget, "");
    setMessage(widget, "", "");

    if (widget.dataset.context === "cart") {
      resetCartEstimatedTotal();
    }
  }

  function applyOptionSelectionToWidget(widget, option, cart) {
    if (option.eligible === false) return;
    ensureWidgetState(widget);
    widget.state.selectedOption = option;
    markSelectedRow(widget, option.option_key);
    const continuation = widget.querySelector("[data-frete-continue]");
    if (continuation && widget.dataset.checkoutRequested === "true") continuation.hidden = false;
    setMessage(widget, "", "");

    if (widget.dataset.context === "cart") {
      if (cart && typeof cart.total_price !== "undefined") {
        syncCartEstimatedTotalWithShipping(cart, option);
        return;
      }

      const savedState = loadState();
      if (typeof savedState.cart_total_price !== "undefined") {
        syncCartEstimatedTotalWithShipping({ total_price: Number(savedState.cart_total_price) || 0 }, option);
      }
    }
  }

  function clearSelectionAcrossWidgets(sourceWidget) {
    document.querySelectorAll("[data-frete-widget]").forEach((widget) => {
      if (widget === sourceWidget) return;
      clearWidgetSelection(widget);
    });
  }

  function syncSelectionAcrossWidgets(sourceWidget, selectedOption) {
    const sourceZipcode = maskZipcode(sourceWidget && sourceWidget.state ? sourceWidget.state.zipcode : "");

    document.querySelectorAll("[data-frete-widget]").forEach((widget) => {
      if (widget === sourceWidget) return;

      ensureWidgetState(widget);

      const input = widget.querySelector("[data-frete-widget-zipcode]");
      if (input && sourceZipcode) {
        input.value = sourceZipcode;
      }

      if (sourceZipcode) {
        widget.state.zipcode = normalizeZipcode(sourceZipcode);
      }

      const equivalentOption = Array.isArray(widget.state.options)
        ? widget.state.options.find((option) => shippingOptionKeysMatch(option.option_key, selectedOption.option_key))
        : null;

      applyOptionSelectionToWidget(widget, equivalentOption || selectedOption, null);
    });
  }

  function handleOptionSelection(widget, option, cart) {
    if (option.eligible === false) return;
    ensureWidgetState(widget);

    applyOptionSelectionToWidget(widget, option, cart);
    persistSelectedOption(widget, option, cart);
    syncSelectionAcrossWidgets(widget, option);
  }

  function renderOptions(widget, options, preferredOptionKey, cart) {
    const body = widget.querySelector("[data-frete-widget-options]");
    if (!body) return;

    body.innerHTML = "";
    widget.state.options = options;
    widget.state.selectedOption = null;

    if (!Array.isArray(options) || options.length === 0) {
      setMessage(widget, "Nenhuma opção de frete disponível para este CEP.", "error");
      if (widget.dataset.context === "cart") {
        resetCartEstimatedTotal();
      }
      return;
    }

    setAddress(widget, buildAddressLabel(options[0]));
    setMessage(widget, "", "");

    const radioGroupName = `frete-option-${widget.dataset.context || "widget"}-${Array.from(document.querySelectorAll("[data-frete-widget]")).indexOf(widget)}`;

    options.forEach((option, optionIndex) => {
      const row = document.createElement("tr");
      row.className = "frete-widget__row";
      row.dataset.freteOptionRow = "true";
      row.dataset.optionKey = option.option_key;
      const disabled = option.eligible === false;
      row.setAttribute("aria-disabled", String(disabled));
      if (disabled) row.style.cursor = "not-allowed";
      row.setAttribute("aria-selected", "false");

      const radioId = `${radioGroupName}-${optionIndex}`;

      row.innerHTML = `
        <td>
          <span class="frete-widget__service-choice">
            <input class="frete-widget__radio" type="radio" id="${radioId}" name="${radioGroupName}" ${disabled ? "disabled" : ""} data-frete-option-radio aria-label="Selecionar ${escapeHtml(option.service_name || "frete")}">
            ${renderServiceDisplay(option)}
          </span>
        </td>
        <td>
          <span class="frete-widget__cell-main">${option.previsao_entrega || option.delivery_label || "N/A"}</span>
          ${option.promotion === "free_shipping_700" ? `<small style="display:block;margin-top:6px">${!option.pac_available ? "PAC indisponível para este CEP" : option.remaining_cents > 0 ? `Faltam ${(option.remaining_cents / 100).toLocaleString("pt-BR", {style:"currency",currency:"BRL"})} para conseguir frete grátis` : "Você conseguiu frete grátis!"}</small>` : ""}
        </td>
        <td>
          <span class="frete-widget__cell-price">${option.free_shipment ? "Grátis" : option.formated_price}</span>
        </td>
      `;

      row.addEventListener("click", (event) => {
        if (event.target instanceof HTMLInputElement && event.target.matches("[data-frete-option-radio]")) return;
        if (!disabled) handleOptionSelection(widget, option, cart);
      });
      row.querySelector("[data-frete-option-radio]")?.addEventListener("change", () => handleOptionSelection(widget, option, cart));

      body.appendChild(row);
    });

    const deliveryOptions = options.filter((option) => !option.is_pickup && !option.promotion && option.eligible !== false);
    const preferredOption = options.find((option) => option.eligible !== false && shippingOptionKeysMatch(option.option_key, preferredOptionKey));
    const cheapestDeliveryOption = deliveryOptions.reduce((cheapest, option) => {
      if (!cheapest) return option;
      return Number(option.price) < Number(cheapest.price) ? option : cheapest;
    }, null);
    const lostFreeSelection = preferredOptionKey === "free_shipping_700" && !preferredOption;
    const optionToSelect = widget.state.requirePreferredOption || lostFreeSelection ? preferredOption : preferredOption || cheapestDeliveryOption;
    if (!optionToSelect) {
      clearWidgetSelection(widget);
      if (lostFreeSelection) clearSelectionPreservingZipcode(widget.state.zipcode);
    }
    if (optionToSelect) {
      handleOptionSelection(widget, optionToSelect, cart);
    }
  }

  async function calculateAndRender(widget, params) {
    const continuation = widget.querySelector("[data-frete-continue]");
    if (continuation) continuation.hidden = true;
    ensureWidgetState(widget);
    const input = widget.querySelector("[data-frete-widget-zipcode]");
    const zipcode = normalizeZipcode((params && params.zipcode) || (input ? input.value : ""));

    if (zipcode.length !== 8) {
      if (!(params && params.silent)) {
        setMessage(widget, "CEP inválido.", "error");
      }
      clearSelectionPreservingZipcode(zipcode);
      return null;
    }

    let total = getContextTotal(widget);
    let cart = await fetchCartJson();

    if (widget.dataset.context === "cart") {
      total = (Number(cart.total_price) || 0) / 100;
    }

    const weightGrams = getRequestWeightGrams(widget, cart);

    widget.state.zipcode = zipcode;
    const calculationId = (widget.state.calculationId || 0) + 1;
    widget.state.calculationId = calculationId;
    widget.dataset.freteRecalculating = "true";
    updateButtonLoading(widget, true);
    if (!(params && params.silent)) {
      setMessage(widget, "Calculando frete...", "info");
    }

    try {
      const response = await postJson(widget.dataset.endpoint, {
        action: "calculate_shipping",
        zipcode,
        total,
        weightGrams,
        cart_total: (Number(cart.total_price) || 0) / 100,
        context: widget.dataset.context,
      });

      if (widget.state.calculationId !== calculationId) return null;
      const preferredOptionKey = params && Object.prototype.hasOwnProperty.call(params, "preferredOptionKey")
        ? params.preferredOptionKey
        : widget.state.selectedOption?.option_key;
      renderOptions(widget, response.data || [], preferredOptionKey, cart);
      widget.state.lastAutoCalculatedZipcode = zipcode;

      if (!widget.state.selectedOption) {
        clearSelectionPreservingZipcode(zipcode);
        if (!(params && params.silent) && widget.dataset.context === "cart") {
          setMessage(widget, "Selecione uma opção de frete para continuar.", "info");
        }
        if (widget.dataset.context === "cart") {
          resetCartEstimatedTotal();
        }
      }

      return {
        cart,
        selectedOption: widget.state.selectedOption,
      };
    } catch (error) {
      if (widget.state.calculationId !== calculationId) return null;
      clearWidgetSelection(widget);
      clearSelectionPreservingZipcode(zipcode);
      setAddress(widget, "");
      const body = widget.querySelector("[data-frete-widget-options]");
      if (body) body.innerHTML = "";
      if (widget.dataset.context === "cart") {
        resetCartEstimatedTotal();
      }
      widget.state.lastAutoCalculatedZipcode = "";
      if (!(params && params.silent)) {
        setMessage(
          widget,
          getFriendlyErrorMessage(
            error,
            "Não foi possível calcular o frete agora. Verifique sua conexão com a internet e tente novamente."
          ),
          "error"
        );
      }
      return null;
    } finally {
      if (widget.state.calculationId === calculationId) {
        delete widget.dataset.freteRecalculating;
        updateButtonLoading(widget, false);
      }
    }
  }

  async function restoreStateForWidget(widget) {
    const savedState = loadState();
    const input = widget.querySelector("[data-frete-widget-zipcode]");
    if (!input || !savedState.zipcode) return;

    input.value = maskZipcode(savedState.zipcode);

    const normalizedZipcode = normalizeZipcode(savedState.zipcode);
    widget.state.zipcode = normalizedZipcode;

    if (normalizedZipcode.length !== 8) {
      return;
    }

    await calculateAndRender(widget, {
      zipcode: normalizedZipcode,
      preferredOptionKey: savedState.selected_option_key || null,
      silent: false,
    });
  }

  function initWidget(widget) {
    if (widget.dataset.freteWidgetReady === "true") {
      ensureWidgetState(widget);
      return;
    }
    widget.dataset.freteWidgetReady = "true";
    ensureWidgetState(widget);

    const input = widget.querySelector("[data-frete-widget-zipcode]");
    const button = widget.querySelector("[data-frete-widget-calculate]");
    const continuation = widget.querySelector("[data-frete-continue]");
    if (continuation) continuation.addEventListener("click", () => {
      const scope = widget.closest('.product-information, .product-details, section[data-section-type="main-product"], .product, .shopify-section') || document;
      const original = scope.querySelector('button[data-direct-checkout="true"]') || document.querySelector('button[data-direct-checkout="true"]');
      if (original && !original.disabled) original.click();
    });

    if (input) {
      input.addEventListener("input", () => {
        input.value = maskZipcode(input.value);

        const normalizedZipcode = normalizeZipcode(input.value);
        const currentState = loadState();
        if (normalizeZipcode(currentState.zipcode) !== normalizedZipcode) {
          clearSelectionPreservingZipcode(normalizedZipcode);
          clearWidgetSelection(widget);
          clearSelectionAcrossWidgets(widget);
        }

        if (widget.state.autoCalculateTimer) {
          window.clearTimeout(widget.state.autoCalculateTimer);
          widget.state.autoCalculateTimer = null;
        }

        if (normalizedZipcode.length !== 8) {
          widget.state.lastAutoCalculatedZipcode = "";
          return;
        }

        if (widget.state.lastAutoCalculatedZipcode === normalizedZipcode) {
          return;
        }

        widget.state.autoCalculateTimer = window.setTimeout(() => {
          widget.state.autoCalculateTimer = null;
          if (widget.state.lastAutoCalculatedZipcode === normalizedZipcode) {
            return;
          }

          calculateAndRender(widget, {
            zipcode: normalizedZipcode,
            silent: false,
          });
        }, 250);
      });

      input.addEventListener("change", () => {
        const currentState = loadState();
        if (normalizeZipcode(currentState.zipcode) !== normalizeZipcode(input.value)) {
          clearSelectionPreservingZipcode(input.value);
          clearWidgetSelection(widget);
          clearSelectionAcrossWidgets(widget);
        }
      });

      input.addEventListener("keypress", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          if (widget.state.autoCalculateTimer) {
            window.clearTimeout(widget.state.autoCalculateTimer);
            widget.state.autoCalculateTimer = null;
          }
          calculateAndRender(widget, { silent: false });
        }
      });
    }

    if (widget.dataset.context === "product") {
      const productScope = widget.closest("product-form-component, form[action*='/cart/add'], .product-details, main") || document;
      productScope.querySelectorAll('input[name="quantity"]').forEach((quantityInput) => {
        quantityInput.addEventListener("change", () => invalidateFreteSelectionForWidget(widget));
        quantityInput.addEventListener("input", () => invalidateFreteSelectionForWidget(widget));
      });
    }

    if (button) {
      button.addEventListener("click", () => {
        if (widget.state.autoCalculateTimer) {
          window.clearTimeout(widget.state.autoCalculateTimer);
          widget.state.autoCalculateTimer = null;
        }
        calculateAndRender(widget, { silent: false });
      });
    }

    restoreStateForWidget(widget);
  }

  async function ensureValidCartSelection(widget, showErrors) {
    ensureWidgetState(widget);
    const state = loadState();
    const zipcode = normalizeZipcode(state.zipcode);
    const selectedOptionKey = state.selected_option_key;

    if (zipcode.length !== 8 || !selectedOptionKey) {
      if (showErrors) {
        const message = zipcode.length !== 8
          ? "Informe um CEP válido para continuar."
          : "Selecione uma opção de frete para continuar.";
        setMessage(widget, message, "error");
        window.CintaToast?.show(message, "error");
      }
      return null;
    }

    const result = await calculateAndRender(widget, {
      zipcode,
      preferredOptionKey: selectedOptionKey,
      silent: !showErrors,
    });

    if (!result || !result.selectedOption) {
      if (showErrors) {
        setMessage(widget, "A opção de frete precisa ser recalculada e selecionada novamente.", "error");
        window.CintaToast?.show(
          "A opção de frete precisa ser recalculada e selecionada novamente.",
          "error"
        );
      }
      return null;
    }

    return result;
  }

  async function ensureValidProductSelection(widget, showErrors) {
    ensureWidgetState(widget);

    const input = widget.querySelector("[data-frete-widget-zipcode]");
    const selectedRow = widget.querySelector('[data-frete-option-row][aria-selected="true"], .frete-widget__row--selected');
    const savedState = loadState();
    const zipcode = normalizeZipcode(widget.state.zipcode || (input ? input.value : "") || savedState.zipcode);
    const selectedOptionKey =
      widget.state.selectedOption?.option_key ||
      selectedRow?.dataset.optionKey ||
      savedState.selected_option_key ||
      "";

    if (zipcode.length !== 8 || !selectedOptionKey) {
      if (showErrors) {
        const message = zipcode.length !== 8
          ? "Informe um CEP válido para continuar."
          : "Selecione uma opção de frete para continuar.";
        setMessage(widget, message, "error");
        window.CintaToast?.show(message, "error");
      }
      return null;
    }

    let cart = null;

    try {
      cart = await fetchCartJson();
      widget.state.zipcode = zipcode;
      setMessage(widget, "Conferindo frete...", "info");

      const response = await postJson(widget.dataset.endpoint, {
        action: "calculate_shipping",
        zipcode,
        total: (Number(cart.total_price) || 0) / 100,
        context: "cart",
      });

      const options = response.data || [];
      const selectedOption = options.find((option) => option.eligible !== false && shippingOptionKeysMatch(option.option_key, selectedOptionKey));

      if (!selectedOption) {
        if (showErrors) {
          setMessage(widget, "A opção de frete precisa ser recalculada e selecionada novamente.", "error");
          window.CintaToast?.show(
            "A opção de frete precisa ser recalculada e selecionada novamente.",
            "error"
          );
        }
        return null;
      }

      widget.state.options = options;
      applyOptionSelectionToWidget(widget, selectedOption, cart);
      persistSelectedOption(widget, selectedOption, cart);
      syncSelectionAcrossWidgets(widget, selectedOption);

      return {
        cart,
        selectedOption,
      };
    } catch (error) {
      if (showErrors) {
        setMessage(
          widget,
          getFriendlyErrorMessage(
            error,
            "Não foi possível calcular o frete agora. Verifique sua conexão com a internet e tente novamente."
          ),
          "error"
        );
      }
      return null;
    }
  }

  async function createDraftCheckout(widget, paymentMethod = "normal") {
    ensureWidgetState(widget);
    if (widget.state.checkoutSubmitting || widget.state.emailCapturePending) return;
    if (paymentMethod === "pix" && (!document.querySelector("[data-pix-draft-checkout]") || isPrecheckoutEnabled(widget))) {
      setMessage(widget, "O checkout Pix não está disponível neste acesso.", "error");
      return;
    }

    widget.state.emailCapturePending = true;

    try {
      const validSelection = await ensureValidCartSelection(widget, true);
      if (!validSelection || !validSelection.cart || !validSelection.selectedOption) {
        return;
      }

      const checkoutContact = await requestCheckoutEmail(widget);
      if (!checkoutContact) {
        setMessage(widget, "Informe o e-mail para continuar.", "info");
        return;
      }

      scrollToFreightWidget(widget);
      widget.state.checkoutSubmitting = true;
      setCheckoutLoading(widget, true);
      setMessage(widget, "Preparando...", "info");
      await submitDraftCheckout(widget, validSelection.cart, validSelection.selectedOption, checkoutContact, paymentMethod);
    } catch (error) {
      setMessage(
        widget,
        getFriendlyErrorMessage(
          error,
          "Não foi possível preparar o pedido agora. Verifique sua conexão com a internet e tente novamente."
        ),
        "error"
      );
      setCheckoutLoading(widget, false);
    } finally {
      widget.state.emailCapturePending = false;
      widget.state.checkoutSubmitting = false;
    }
  }

  async function createDraftCheckoutFromProduct(widget, paymentMethod = "normal") {
    ensureWidgetState(widget);
    if (widget.state.checkoutSubmitting || widget.state.emailCapturePending) return false;
    if (!["normal", "pix"].includes(paymentMethod)
      || (paymentMethod === "pix" && (widget.dataset.pixCheckoutEnabled !== "true" || isPrecheckoutEnabled(widget)))) {
      setMessage(widget, "O checkout Pix não está disponível neste acesso.", "error");
      return false;
    }


    widget.state.emailCapturePending = true;

    try {
      const validSelection = await ensureValidProductSelection(widget, true);
      if (!validSelection || !validSelection.cart || !validSelection.selectedOption) {
        return false;
      }

      const checkoutContact = await requestCheckoutEmail(widget);
      if (!checkoutContact) {
        setMessage(widget, "Informe o e-mail para continuar.", "info");
        return false;
      }

      scrollToFreightWidget(widget);
      widget.state.checkoutSubmitting = true;
      setCheckoutLoading(widget, true);
      setMessage(widget, "Preparando...", "info");
      await submitDraftCheckout(widget, validSelection.cart, validSelection.selectedOption, checkoutContact, paymentMethod);
      return true;
    } catch (error) {
      setMessage(
        widget,
        getFriendlyErrorMessage(
          error,
          "Não foi possível preparar o pedido agora. Verifique sua conexão com a internet e tente novamente."
        ),
        "error"
      );
      setCheckoutLoading(widget, false);
      return false;
    } finally {
      widget.state.emailCapturePending = false;
      widget.state.checkoutSubmitting = false;
    }
  }

  function isPrecheckoutEnabled(widget) {
    return String(widget?.dataset?.precheckoutEnabled || "false") === "true";
  }

  function redirectToPrecheckout(widget) {
    const url = String(widget?.dataset?.precheckoutUrl || '').trim();
    if (!url) {
      throw new Error('A rota do pre-checkout não foi configurada.');
    }

    window.location.href = url;
  }

  function isCartWidgetAvailable() {
    const widget = document.querySelector('[data-frete-widget][data-context="cart"]');
    if (widget) {
      initWidget(widget);
    }
    return widget;
  }

  function interceptCheckoutClick(event) {
    const widget = isCartWidgetAvailable();
    if (!widget) return;

    const target = event.target instanceof Element ? event.target.closest(CHECKOUT_SELECTORS) : null;
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    if (!event.isTrusted) {
      return;
    }

    if (isPrecheckoutEnabled(widget)) {
      try {
        redirectToPrecheckout(widget);
      } catch (error) {
        setMessage(widget, getFriendlyErrorMessage(error, 'Não foi possível abrir o pre-checkout agora.'), 'error');
        setCheckoutLoading(widget, false);
      }
      return;
    }

    createDraftCheckout(widget, target.hasAttribute("data-pix-draft-checkout") ? "pix" : "normal");
  }

  function bootstrap() {
    document.querySelectorAll("[data-frete-widget]").forEach(initWidget);
    resetCartEstimatedTotal();
    document.addEventListener("click", interceptCheckoutClick, true);
    let refreshShippingTimer;
    const refreshShipping = () => {
      window.clearTimeout(refreshShippingTimer);
      refreshShippingTimer = window.setTimeout(() => {
        document.querySelectorAll('[data-frete-widget]').forEach((widget) => {
          initWidget(widget);
          const zipcode = normalizeZipcode(widget.querySelector('[data-frete-widget-zipcode]')?.value || loadState().zipcode);
          if (zipcode.length === 8) calculateAndRender(widget, {zipcode, silent: true});
        });
      }, 250);
    };
    document.addEventListener('cart:update', refreshShipping);
    document.addEventListener('discount:update', refreshShipping);
    document.addEventListener("variant:update", (event) => {
      const widget = document.querySelector('[data-frete-widget][data-context="product"]');
      if (!widget) return;

      const eventProductId = String(event.detail?.data?.productId || "");
      const widgetProductId = String(widget.dataset.productId || "");
      if (eventProductId && widgetProductId && eventProductId !== widgetProductId) {
        return;
      }

      initWidget(widget);
      const refreshed = refreshProductWidgetWeightFromHtml(widget, event.detail?.data?.html);
      const resourceWeight = parsePositiveInteger(event.detail?.resource?.weight || event.detail?.variant?.weight);
      if (!refreshed && resourceWeight > 0) {
        widget.dataset.weightGrams = String(resourceWeight);
      }

      const preferredOptionKey = widget.state.selectedOption?.option_key || loadState().selected_option_key;
      const zipcode = normalizeZipcode(widget.querySelector('[data-frete-widget-zipcode]')?.value || widget.state.zipcode);
      invalidateFreteSelectionForWidget(widget);
      if (zipcode.length === 8) {
        widget.state.requirePreferredOption = Boolean(preferredOptionKey);
        calculateAndRender(widget, { zipcode, preferredOptionKey }).finally(() => {
          widget.state.requirePreferredOption = false;
        });
      }
    });
  }

  window.CintaFreteDraftCheckout = {
    requestPaymentMethod,
    createDraftCheckout,
    createDraftCheckoutFromProduct,
    initWidget,
  };

  window.addEventListener("pageshow", handlePageRestore);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }
})();
